import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { ReportDate } from "./reportDate";

const useStyles = makeStyles(() => ({
  header: {
    fontSize: "64px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
  },
}));

interface ReportHeaderProps {
  logoImg: React.ReactNode;
  valuationTitleClassName: string;
  reportTitleClassName: string;
}

export const ReportHeader = ({ logoImg, valuationTitleClassName, reportTitleClassName }: ReportHeaderProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.header}
    >
      {logoImg}
      <Box display="flex">
        <Typography className={valuationTitleClassName}>
          Valuation
        </Typography>
        <Typography className={reportTitleClassName}>Report</Typography>
      </Box>
      <ReportDate date={new Date()} />
    </Box>
  );
}